import type { RohsComponentComplianceFileDetailView } from '@/shared/hooks/api/rohsComplianceFiles'
import type { ComponentRohsBriefingStep } from '@/shared/briefing/buildComponentRohsBriefing'
import { useCanWriteOrgData } from '@/shared/hooks/useCanWriteOrgData'
import { V2ComponentRohsBriefingStepShell } from './V2ComponentRohsBriefingStepShell'
import { V2ComponentRohsSignOffActions } from './V2ComponentRohsSignOffActions'

export function V2ComponentRohsSignOffStep({
  step,
  index,
  componentId,
  file,
}: {
  step: ComponentRohsBriefingStep
  index: number
  componentId: string
  file: RohsComponentComplianceFileDetailView
}) {
  const canWrite = useCanWriteOrgData()

  return (
    <V2ComponentRohsBriefingStepShell
      step={step}
      index={index}
      actions={
        canWrite ? (
          <V2ComponentRohsSignOffActions componentId={componentId} file={file} />
        ) : undefined
      }
    />
  )
}
